// extracted by mini-css-extract-plugin
module.exports = {"expanded":"BasicCell_expanded__yl6Xj","expandButton":"BasicCell_expandButton__1aw7F"};